import styled from 'styled-components';
import { ThemeMode } from '../../../../../../global-state/themeContext';
import { Typography } from '../../../../../../stories/atoms';
import { RowFlexContainer } from '../../../../../../stories/atoms/containerV2/ContainerV2';
import { muiTheme, percentToHex } from '../../../../../../theme';

const getBackgroundColor = (status: 'positive' | 'negative', mode: ThemeMode) => {
  if (status === 'positive') {
    return mode === 'dark'
      ? percentToHex(muiTheme.color.validationGreen, 24)
      : percentToHex(muiTheme.color.success, 32);
  } else {
    return mode === 'dark' ? percentToHex(muiTheme.color.red, 16) : percentToHex(muiTheme.color.error, 24);
  }
};

const getTextColor = (status: 'positive' | 'negative', mode: ThemeMode) => {
  if (status === 'positive') {
    return mode === 'dark' ? muiTheme.color.success : muiTheme.color.validationGreen;
  } else {
    return mode === 'dark' ? muiTheme.color.error : muiTheme.color.red;
  }
};

export const StyledMetricContainer = styled(RowFlexContainer)<{ status: 'positive' | 'negative' }>`
  background-color: ${({ theme: { palette }, status }) => getBackgroundColor(status, palette.mode)};
`;

export const StyledTypography = styled(Typography)<{ status: 'positive' | 'negative' }>`
  color: ${({ theme: { palette }, status }) => getTextColor(status, palette.mode)};
`;
